import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Navigation, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

const GeolocationButton = ({ onLocationFound, variant = 'outline', size = 'default', className = '' }) => {
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const language = i18n.language === 'pt-BR' || i18n.language === 'pt' ? 'pt' : 'en';

  const texts = {
    pt: {
      notSupported: 'Geolocalização não suportada pelo seu navegador',
      success: 'Localização obtida com sucesso!',
      error: 'Erro ao obter localização',
      denied: 'Permissão de localização negada',
      unavailable: 'Localização indisponível',
      timeout: 'Tempo esgotado ao obter localização',
      loading: 'Obtendo...',
      nearMe: 'Perto de Mim',
    },
    en: {
      notSupported: 'Geolocation not supported by your browser',
      success: 'Location obtained successfully!',
      error: 'Error getting location',
      denied: 'Location permission denied',
      unavailable: 'Location unavailable',
      timeout: 'Timeout getting location',
      loading: 'Getting...',
      nearMe: 'Near Me',
    }
  };

  const t = texts[language] || texts.en;

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      toast.error(t.notSupported);
      return;
    }

    setLoading(true);
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        
        if (onLocationFound) {
          onLocationFound({ latitude, longitude });
        }
        
        toast.success(t.success);
        setLoading(false);
      },
      (error) => {
        console.error('Geolocation error:', error);
        
        let message = t.error;
        if (error.code === error.PERMISSION_DENIED) {
          message = t.denied;
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          message = t.unavailable;
        } else if (error.code === error.TIMEOUT) {
          message = t.timeout;
        }
        
        toast.error(message);
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleGetLocation}
      disabled={loading}
      className={className}
      data-testid="geolocation-button"
    >
      {loading ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          {t.loading}
        </>
      ) : (
        <>
          <Navigation className="w-4 h-4 mr-2" />
          {t.nearMe}
        </>
      )}
    </Button>
  );
};

export default GeolocationButton;
